import React from 'react'
const SvgFilter = ({ title, ...props }) => (
  <svg
    width="0.75"
    height="0.75"
    viewBox="0 0 12 12"
    {...{ ...props, rotated: undefined }}
  >
    <title>{title}</title>
    <path
      fillRule="currentColor"
      d="M3.99984 4C4.87065 4 5.61148 3.44346 5.88603 2.66667H10.6665L10.7443 2.66218C11.0758 2.62367 11.3332 2.34189 11.3332 2C11.3332 1.63181 11.0347 1.33333 10.6665 1.33333H5.88603C5.61148 0.556538 4.87065 0 3.99984 0C3.12902 0 2.3882 0.556538 2.11364 1.33333H1.33317L1.25542 1.33782C0.923864 1.37633 0.666504 1.65811 0.666504 2C0.666504 2.36819 0.964981 2.66667 1.33317 2.66667H2.11364C2.3882 3.44346 3.12902 4 3.99984 4ZM4.6665 2C4.6665 2.36819 4.36803 2.66667 3.99984 2.66667C3.63165 2.66667 3.33317 2.36819 3.33317 2C3.33317 1.63181 3.63165 1.33333 3.99984 1.33333C4.36803 1.33333 4.6665 1.63181 4.6665 2Z"
      fill="currentColor"
    />
    <path
      fillRule="currentColor"
      d="M7.99984 8C8.87065 8 9.61147 7.44346 9.88603 6.66667H10.6665L10.7443 6.66218C11.0758 6.62367 11.3332 6.34189 11.3332 6C11.3332 5.63181 11.0347 5.33333 10.6665 5.33333H9.88603C9.61147 4.55654 8.87065 4 7.99984 4C7.12902 4 6.3882 4.55654 6.11364 5.33333H1.33317L1.25542 5.33782C0.923864 5.37633 0.666504 5.65811 0.666504 6C0.666504 6.36819 0.964981 6.66667 1.33317 6.66667H6.11364C6.3882 7.44346 7.12902 8 7.99984 8ZM8.6665 6C8.6665 6.36819 8.36803 6.66667 7.99984 6.66667C7.63165 6.66667 7.33317 6.36819 7.33317 6C7.33317 5.63181 7.63165 5.33333 7.99984 5.33333C8.36803 5.33333 8.6665 5.63181 8.6665 6Z"
      fill="currentColor"
    />
    <path
      fillRule="currentColor"
      d="M5.88603 10.6667H10.6665L10.7443 10.6622C11.0758 10.6237 11.3332 10.3419 11.3332 10C11.3332 9.63181 11.0347 9.33333 10.6665 9.33333H5.88603C5.61148 8.55654 4.87065 8 3.99984 8C3.12902 8 2.3882 8.55654 2.11364 9.33333H1.33317L1.25542 9.33782C0.923864 9.37633 0.666504 9.65811 0.666504 10C0.666504 10.3682 0.964981 10.6667 1.33317 10.6667H2.11364C2.3882 11.4435 3.12902 12 3.99984 12C4.87065 12 5.61148 11.4435 5.88603 10.6667ZM4.6665 10C4.6665 10.3682 4.36803 10.6667 3.99984 10.6667C3.63165 10.6667 3.33317 10.3682 3.33317 10C3.33317 9.63181 3.63165 9.33333 3.99984 9.33333C4.36803 9.33333 4.6665 9.63181 4.6665 10Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgFilter
